import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { intl } from "LocaleWrapper";
import { VatCodeType } from "__generated__/enums";

const VatCodeTypeSelect = ({ ...rest }: Omit<SelectProps<VatCodeType, false>, "fetchOptions" | "paginated" | "disableSearch">) => {
	return (
		<Select
			{...rest}
			fetchOptions={Object.values(VatCodeType)}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			disableSearch />
	);
};

export default VatCodeTypeSelect;
